<template>
    <div>
        <div class="flex justify-between border-b border-grayxlight mb-3">
            <div class="text-[13px] semibold text-darkgray">Копирование смены</div>
            <div class="text-xs text-graytextlight cursor-pointer" @click="isOpen = !isOpen">
                <span v-if="isOpen">Свернуть</span>
                <span v-else>Развернуть</span>
            </div>
        </div>
        <div v-if="isOpen">
            <div class="text-gray text-xs mb-3">Выберите дни для копирования</div>
            <div class="w-full mb-2">
                <AppCalendar
                    :model-value="selectedDates"
                    mode="multi"
                    :source-dates="[sourceDay]"
                    :occupied-dates="occupiedDates"
                    :hr-deviation-dates="hrDeviationDates"
                    :hr-deviation-labels="hrDeviationLabels"
                    :min-date="minimumTargetDate"
                    :initial-date="store.currentScheduleDate"
                    large
                    copy-state-styles
                    @update:model-value="onMultiSelect"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import type { Dayjs } from 'dayjs'
import { computed, ref } from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import AppCalendar from '@/ui/AppCalendar.vue'
import { useToast } from 'vue-toast-notification'

const store = useScheduleStore()
const toast = useToast({ position: 'top' })
const { dt } = defineProps<{ dt: string }>()
const emit = defineEmits<{
    'on-copy': [targetDates: string[]]
}>()
const isOpen = ref(false)
const selectedDates = ref<Dayjs[]>([])

const sourceDay = computed(() => dayjs(dt))
const minimumTargetDate = computed(() => dayjs().add(1, 'day').startOf('day'))
const currentSchedule = computed(() => store.schedules.find(item => item.id === store.currentShift?.employment))
const monthShifts = computed(() => currentSchedule.value?.shifts.filter(shift => (
    shift.date && dayjs(shift.date).isSame(store.currentScheduleDate, 'month') && !shift.is_vacancy
)) ?? [])
const hrDeviationDates = computed<Dayjs[]>(() => monthShifts.value
    .filter(shift => Boolean(shift.day_state_document))
    .map(shift => dayjs(shift.date)))
const hrDeviationLabels = computed<Record<string, string>>(() => monthShifts.value
    .filter(shift => Boolean(shift.day_state_document) && shift.date)
    .reduce<Record<string, string>>((labels, shift) => {
        const dayType = store.dayTypes.find(item => item.id === shift.day_type)
        if (dayType?.name) labels[dayjs(shift.date).format('YYYY-MM-DD')] = dayType.name
        return labels
    }, {}))
const occupiedDates = computed<Dayjs[]>(() => monthShifts.value
    .filter(shift => !shift.day_state_document)
    .map(shift => dayjs(shift.date)))

function onMultiSelect(value: Dayjs | [Dayjs, Dayjs] | Dayjs[]) {
    const dates = value as Dayjs[]
    if (dates.some(date => !date.isSame(store.currentScheduleDate, 'month'))) {
        toast.error('Для копирования доступны только даты текущего месяца')
    }
    selectedDates.value = dates.filter(date => date.isSame(store.currentScheduleDate, 'month'))
    emit('on-copy', selectedDates.value.map(date => date.format('YYYY-MM-DD')).sort())
}
</script>
